module.exports = __webpack_public_path__ + "static/media/flutterLogo.f2e3fb32.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Technologies/Assets/flutterLogo.svg
// module id = 516
// module chunks = 1